// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__OXh0l","title":"Images45_title__35C5U","images":"Images45_images__1iQHd"};